module.exports = __webpack_public_path__ + "static/media/logo.f05654c1.png";